if (GT && GT.agent && GT.agent.os && GT.agent.os.family && GT.agent.os.family.indexOf('Mac') !== -1) {
  document.getElementsByTagName('html')[0].classList.add('mac-swipe-action-scroll-fix');
}

